export var isMobileDevice = function () { return (typeof window.orientation !== "undefined")
    || (navigator.userAgent.indexOf("IEMobile") !== -1); };
export var isDesktopDevice = function () { return !isMobileDevice(); };
